(() => {
	const dialog = document.getElementById('FinalSaleDialog');
	if (!dialog) return;

	const confirmButton = dialog.querySelector('[data-final-sale-confirm]');
	const cancelButtons = dialog.querySelectorAll('[data-final-sale-cancel]');
	let pendingSubmission = null;

	const isFinalSaleForm = (form) => {
		if (!(form instanceof HTMLFormElement)) return false;

		const action = form.getAttribute('action') || '';
		return action.includes('/cart/add') && form.dataset.finalSale === 'true';
	};

	const closeDialog = () => {
		pendingSubmission = null;

		if (typeof dialog.close === 'function' && dialog.open) {
			dialog.close();
		} else {
			dialog.removeAttribute('open');
		}
	};

	const openDialog = () => {
		if (typeof dialog.showModal === 'function') {
			dialog.showModal();
		} else {
			dialog.setAttribute('open', '');
		}

		confirmButton.focus();
	};

	document.addEventListener('submit', (event) => {
		const form = event.target;
		if (!isFinalSaleForm(form)) return;

		if (form.dataset.finalSaleConfirmed === 'true') {
			delete form.dataset.finalSaleConfirmed;
			return;
		}

		event.preventDefault();
		event.stopImmediatePropagation();

		pendingSubmission = {
			form,
			submitter: event.submitter instanceof HTMLElement ? event.submitter : null
		};
		openDialog();
	}, true);

	confirmButton.addEventListener('click', () => {
		if (!pendingSubmission) return;

		const { form, submitter } = pendingSubmission;
		pendingSubmission = null;
		form.dataset.finalSaleConfirmed = 'true';

		if (typeof dialog.close === 'function' && dialog.open) {
			dialog.close();
		} else {
			dialog.removeAttribute('open');
		}

		if (typeof form.requestSubmit === 'function') {
			if (submitter && submitter.isConnected) {
				form.requestSubmit(submitter);
			} else {
				form.requestSubmit();
			}
		} else {
			form.submit();
		}
	});

	cancelButtons.forEach((button) => button.addEventListener('click', closeDialog));

	dialog.addEventListener('cancel', (event) => {
		event.preventDefault();
		closeDialog();
	});

	dialog.addEventListener('click', (event) => {
		if (event.target === dialog) closeDialog();
	});
})();
